import React, { useState, useEffect } from 'react';
import { Form, Input, Select, Button, Drawer, message, Col, Row, DatePicker } from 'antd';
import { postApiWithAuthToken, getApiWithAuthToken, getApiWithPublicAuthToken, updateApiWithAuthToken } from '../../../api';

const CountryManagerForm = ({ handleDrawerClose, isDrawerVisible, getCountryManagerList, CountryManager }) => {
    const [form] = Form.useForm();

    // Get dropdown data 
    const [managerList, setManagerList] = useState([]);
    const [countryList, setCountryList] = useState([]);

    function getManagerList() {
        getApiWithAuthToken('/api/v1/admin/managers').then((res) => {
            if (res.data && res.data.length > 0) {
                setManagerList(res.data);
            }
        });
    }
    function getCountryList() {
        getApiWithPublicAuthToken('/api/v1/public/countryList').then((res) => {
            if (res.data && res.data.length > 0) {
                setCountryList(res.data);
            }
        });
    }

    useEffect(() => {
        getManagerList();
        getCountryList();
    }, []);

    useEffect(() => {
        form.resetFields();
    }, [CountryManager]);

    // Form Submit 

    const handleSubmit = () => {
        form.submit();
    };

    const onFinish = (values) => {
        message.loading({ content: 'Processing...', key: 'form' });

        if (CountryManager.id) {
            updateApiWithAuthToken(`/api/v1/admin/companyCountries/${CountryManager.id}`, values).then((res) => {
                if (!res.error) {
                    setTimeout(() => {
                        message.success({ content: res.msg, key: 'form' });
                    }, 500);
                    handleDrawerClose();
                    getCountryManagerList();
                } else {
                    setTimeout(() => {
                        if (res.errors.length) {
                            res.errors.map((each) => {
                                message.error({ content: each.msg, key: 'form' });
                                return null;
                            });
                        } else {
                            message.error({ content: res.errors, key: 'form' });
                        }
                    }, 500);
                }
            });
        } else {
            postApiWithAuthToken('/api/v1/admin/companyCountries', values).then((res) => {
                if (!res.error) {
                    setTimeout(() => {
                        message.success({ content: res.msg, key: 'form' });
                    }, 500);
                    handleDrawerClose();
                    getCountryManagerList();
                } else {
                    setTimeout(() => {
                        if (res.errors.length) {
                            res.errors.map((each) => {
                                message.error({ content: each.msg, key: 'form' });
                                return null;
                            });
                        } else {
                            message.error({ content: res.errors, key: 'form' });
                        }
                    }, 500);
                }
            });
        }
    };

    return (
        <Drawer
            title={CountryManager.id ? "Edit country manager" : "Add country manager"}
            width={480}
            onClose={handleDrawerClose}
            visible={isDrawerVisible}
            bodyStyle={{ paddingBottom: 80 }}
            footer={
                <div style={{ textAlign: 'right', }}>
                    <Button onClick={handleDrawerClose} style={{ marginRight: 8 }}>
                        Cancel
                    </Button>
                    <Button onClick={handleSubmit} type="primary">
                        Submit
                    </Button>
                </div>
            }
        >
            <Form layout="vertical"
                hideRequiredMark
                form={form}
                initialValues={{ remember: true }}
                onFinish={onFinish} >
                <Form.Item
                    name="manager"
                    label="Manager"
                    initialValue={managerList.find(manager => manager.name === CountryManager.manager) ? managerList.find(manager => manager.name === CountryManager.manager).id : null}
                    rules={[{ required: true, message: 'This field is required' }]}
                >
                    <Select
                        showSearch
                        placeholder="Select a manager"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }>
                        {managerList.length &&
                            managerList.map((item) => (
                                <Select.Option
                                    key={item.id}
                                    value={item.id}
                                >
                                    {item.name}
                                </Select.Option>
                            ))}
                    </Select>
                </Form.Item>
                {/* <Form.Item
                    name="country"
                    label="Country"
                    initialValue={countryList.find(country => country.name === CountryManager.country) ? countryList.find(country => country.name === CountryManager.country).id : null}
                >
                    <Select
                        showSearch
                        placeholder="Select a country"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }>
                        {countryList.length &&
                            countryList.map((item) => (
                                <Select.Option
                                    key={item.id}
                                    value={item.id}
                                >
                                    {item.name}
                                </Select.Option>
                            ))}
                    </Select>
                </Form.Item> */}
            </Form>
        </Drawer >
    );
};
export default CountryManagerForm;
